import { ProfileTypes } from '@api/Users/User';
import store from '@store/index';
import { buildPermissionSubject, can, Capability, PermissionContext, PermissionSubject } from '@utils/Permissions/Capabilities';

export const hasPermission = (profiles: ProfileTypes[]) => {
    const profileSelected = store.getState().auth.profileSelected;
    if (profileSelected) {
        return profiles.includes(profileSelected);
    }
    const loggedUser = store.getState().auth.loggedUser;
    return profiles.includes(loggedUser!.profile.profile);
};

/**
 * Quién opera ahora: el perfil seleccionado ("Ver como") y, si previsualiza, la
 * sucursal del sidebar (`buildPermissionSubject`). Lee el store UNA vez: en el render
 * de una pantalla va `usePermissionSubject` (`@hooks/usePermissionSubject`), que
 * reacciona al cambio de perfil y de sucursal.
 */
export const getCurrentPermissionSubject = (): PermissionSubject => buildPermissionSubject(store.getState().auth);

/** `can` para quien está operando. La regla vive en `Capabilities`. */
export const canCurrentUser = (capability: Capability, context?: PermissionContext): boolean =>
    can(getCurrentPermissionSubject(), capability, context);
